<template>
  <div class='second'>
    <el-form ref="modify_card" :model="userInfo" class='edit_form' :rules="modifyRules" label-width="100px" size='small'>
      <el-form-item prop='name' label='姓名'>
        <el-input v-model="userInfo.name" :disabled="!isEdit"></el-input>
      </el-form-item>
      <el-form-item prop='changeParks' size="small" label="请选择园区">
        <el-select v-model="value2" :disabled="!isEdit" placeholder="请选择注册园区" @change="selectUser">
          <el-option
            v-for="item in parkLists"
            :key="item.parkId"
            :label="item.parkName"
            :value="item.parkId">
          </el-option>
        </el-select>
        </el-form-item>
      <el-form-item prop='position' label='职位'>
        <el-input v-model="userInfo.position" :disabled="!isEdit"></el-input>
      </el-form-item>
      <el-form-item prop='phone' label='手机'>
        <el-input v-model="userInfo.phone" :disabled="!isEdit"></el-input>
      </el-form-item>
      <el-form-item prop='corpName' label='企业名称'>
        <el-input v-model="userInfo.corpName" :disabled="!isEdit"></el-input>
      </el-form-item>
      <el-form-item prop='address' label='企业地址'>
        <el-input v-model="userInfo.address" :disabled="!isEdit"></el-input>
      </el-form-item>
      <el-form-item prop='tel' label='电话'>
        <el-input v-model="userInfo.tel" :disabled="!isEdit"></el-input>
      </el-form-item>
      <el-form-item prop='email' label='邮箱'>
        <el-input v-model="userInfo.email" :disabled="!isEdit"></el-input>
      </el-form-item>
      <el-form-item class='btn_group'>
        <el-button class='editBtn' @click="editOrCancel" size='small'>{{isEditText}}</el-button>
        <el-button class='saveBtn' @click="save" :disabled="!isEdit" size='small'>保存</el-button>
      </el-form-item>
    </el-form>
    <!-- 提交成功的弹出组件 -->
    <SubmitSuccess v-if='submitSuccessFlag' @close='submitSuccessFlag = false;' class='submit-success' :tipsMsg='tips.tipsMsg' :duration='tips.duration'></SubmitSuccess>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import deepcopy from '@/utils/deepcopy';

export default {
  data() {
    const validateTel = (rule, value, callback) => {
      const reg1 = /^(1[1-9][0-9])\d{8}$/;
      const reg2 = /^(0\d{2})-\d{8}$/;
      const reg3 = /^(0\d{3})-\d{7,8}$/;
      // const reg3 = /^0085[23]-[1-9]\d{7}$/; // 香港号码
      if (value && !reg1.test(value) && !reg2.test(value) && !reg3.test(value)) {
        callback(new Error('电话格式错误!(例：13016432230 或 022-58703120)'));
      } else {
        callback();
      }
    };
    return {
      userInfo: {
        name: '',
        position: '',
        phone: '',
        corpName: '',
        address: '',
        tel: '',
        email: '',
      },
      parkLists: [],
      currentParkName:'',
      value2:'',
      parkValue:'',
      tempUser: {},
      modifyRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'change' },
          { max:50, message:'长度不得超过50个字', trigger: 'change' },
        ],
        changeParks: [
          { required: false, message: '请选择园区', trigger: 'blur' },
        ],
        position: [
          { required: true, message: '请输入职位', trigger: 'change' },
          { max:10, message:'长度不得超过10个字', trigger: 'change' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          { pattern:/^1[3-9]\d{9}$/, message: '手机号格式错误', trigger: 'change' },
        ],
        corpName: [
          { required: true, message: '请输入企业名称', trigger: 'change' },
          { max:50, message:'长度不得超过50字', trigger: 'change' },
        ],
        address: [
          { required: true, message: '请输入企业地址', trigger: 'change' },
          { max:200, message:'长度不得超过200字', trigger: 'change' },
        ],
        tel: [
          { validator: validateTel, trigger: 'change' },
        ],
        email: [
          { type: 'email', message:'请输入正确的邮箱地址', trigger: 'change' },
          { max:100, message:'长度不得超过100字', trigger: 'change' },
        ],
      },
      isEdit: false,
      submitSuccessFlag: false,
      tips: {
        title: '提示',
        tipsMsg: '提交成功！等待企业与您联系。',
        duration: 2000,
      },
    };
  },
  methods: {
    ...mapMutations(['change_token', 'change_user', 'change_parkInfo', 'change_currentParkId']),
    editOrCancel() {
      this.isEdit = !this.isEdit;
      if (this.isEdit) {
        this.tempUser = deepcopy(this.userInfo);
      } else {
        this.userInfo = this.tempUser;
      }
    },
    // 提交
    save() {
      this.$refs.modify_card.validate((valid) => {
        if (valid) {
          this.modifyHttp();
        } else {
          return false;
        }
      });
    },
    chereParkId() {  // 修改用户所属园区
      this.$http.post(`${this.URL_PREFIX}/app/modify/user/info`, {
        parkId:this.parkValue,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          console.log(res);
        }
      });
    },
    // 修改请求
    modifyHttp() {
      this.$http.post(`${this.URL_PREFIX}/app/modify/user/card/info`, {
        ...this.userInfo,
      }, {
        headers: { token: this.token }
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.isEdit = false;
          this.chereParkId();
          this.updateLocalData();
        } else {
          this.submitSuccessFlag=true;
          this.tips.tipsMsg = res.resDesc;
        }
      });
    },
    getParks() {  // 获取园区列表
      this.$http.post(`${this.URL_PREFIX}/app/get/park/info/list`, {
      }, {
        headers: { token: this.token, },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.parkLists = res.resData.pageList ? res.resData.pageList : [];
          if(this.parkLists.length){
            this.parkLists.forEach((v, i)=>{
              if(v.parkId == this.currentParkId){
                this.change_parkInfo(v);
                this.currentParkName = v.parkName;
              }
            })
          }
        }
      });
    },
    selectUser(v){
      console.log(v)
      this.parkValue = v;
    },
    updateLocalData() {
      const user = deepcopy(this.user);
      user.userCardInfo = deepcopy(this.userInfo);
      this.change_user(user);
    }
  },
  computed: {
    ...mapGetters(['user', 'token']),
    isEditText() {
      return this.isEdit ? '取消' : '编辑';
    },
  },
  created() {
    this.userInfo = deepcopy(this.user.userCardInfo);
    this.value2 = deepcopy(this.user.parkId);
    this.getParks();
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.second{
  padding: 30px;
  .edit_form{
    .btn_group{
      text-align: center;
      .editBtn, .saveBtn{
        padding: 6px 34px;
        font-size: 16px;
      }
      .editBtn{
        border-color: $color-main;
        color: $color-main;
      }
      .saveBtn{
        background: $color-main;
        color: #FFF;
        &:disabled{
          background: #999999;
        }
      }
    }
  }
  .submit-success{
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/navigator/personal/components/info/child/Second.vue